import React, { useState, useEffect, memo, useMemo } from "react";
import ValuesStore from "../../store/values-store";
import { useNavigate, useLocation } from "react-router-dom";
import Utilities from "../../dependencies/custom/react-utilities";
import {
  Space,
  Button,
  Card,
  theme,
  Col,
  Row,
  Image,
  Typography,
  Select,
  Input,
} from "antd";

import useTable from "../../hooks/table";

// import useAdd from '../../hooks/add';
// import useDelete from '../../hooks/rest_delete';
import Settings from "../../dependencies/custom/settings";
import CustomFunctions from "../../dependencies/custom/custom-functions";
import useDrawer from "../../hooks/drawer";
import { FilePdfOutlined, EyeOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;
const { TextArea } = Input;

const ApproveDeclineSetup = ({
  label,
  columns,
  saveEndpoint,
  getEndpoint,
  keyName,
  setRecord,
  record,
  itemToView,
  headingKey,
  setItemToview,
  viewJSX /*extraItemToView, setExtraItemToView, extraViewJSX*/,
}) => {
  // console.log(itemToView);
  const location = useLocation();
  const { token } = theme.useToken();
  const drawer = useDrawer();
  const extraDrawer = useDrawer();
  const valuesStore = ValuesStore();
  const [invoices, setInvoices] = useState([]);
  const [remarks, setRemarks] = useState();
  const [status, setStatus] = useState();

  // const add = useAdd('tables_metadata', 'table_name');
  // const del = useDelete();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [hasBootstrapped, setHasBootstrapped] = useState(false);
  //and key value that points to the table names from zustand store.
  const table = useTable(
    {
      pagination: {
        current: 1,
        pageSize: 20,
        hideOnSinglePage: true,
      },
    },
    undefined,
    undefined,
    undefined,
    undefined,
    keyName || "id",
    {},
    {},
  );

  async function bootstrap() {
    table.setLoading(true);
    table.setData([]);
    setRecord?.(undefined);
    if (!getEndpoint) return;
    const res = await Utilities.fetchWithAuth(
      "GET",
      getEndpoint,
      undefined,
      navigate,
    );
    if (res.ok) table.setData(res?.data);
    table.setLoading(false);
  }

  async function fetchInvoice() {
    setInvoices([]);
    if (Utilities.getUrlFileName() == "all_maintenance_requests") {
      if (!itemToView) {
        Utilities.showNotification(undefined, "Record not found");
        return;
      }
      const res = await Utilities.fetchWithAuth(
        "GET",
        `${Settings?.urls?.transport?.repair_invoice}/${itemToView?.id}`,
        undefined,
        navigate,
      );
      if (res?.ok) {
        setInvoices(res?.data?.invoiceData);
      } else {
        Utilities.showNotification(undefined, res?.msg);
      }
    }
  }

  async function submitInvoiceAction() {
    if (Utilities.getUrlFileName() == "all_maintenance_requests") {
      if (status == "Rejected" && !remarks) {
        Utilities.showNotification(
          undefined,
          "Please add a remark for this action",
        );
        return;
      }
      const res = await Utilities.fetchWithAuth(
        "POST",
        `${Settings?.urls?.transport?.repair_approval}`,
        { maintenanceRequestID: itemToView?.id, action: status, remarks },
        navigate,
      );
      if (res?.ok) {
        Utilities.showNotification(undefined, res?.msg, "text-success");
        drawer.setOpen(true);
      } else {
        Utilities.showNotification(undefined, res?.msg);
      }
    }
  }

  useEffect(() => {
    setItemToview?.(undefined); //unmount these state
    setHasBootstrapped(false);
    setInvoices([]);
  }, [location.pathname, record]); //the record here is set to rerender the page after clicking on approve or decline

  useEffect(() => {
    if (itemToView) {
      // console.log(itemToView)
      fetchInvoice();
      drawer.setPlacement("right");
      drawer.setWidth(500);
      drawer.setOpen(true);
      drawer.setTitle(itemToView?.[headingKey] || "Record");
    }
  }, [itemToView]);

  useEffect(() => {
    if (!hasBootstrapped) {
      // table.setAllowSelection(true);
      table.setColumns(columns || []);
      bootstrap();
      setHasBootstrapped(true);
    }
  }, [columns, location.pathname, hasBootstrapped]);

  async function changeStatus(action) {
    if (!saveEndpoint) return;
    table.setLoading(true);
    console.log(table.selectedRowKeys, table.selectedRows);
    if (!saveEndpoint) return;
    table.setLoading(true);
    // const data = [{ [postRequestKey]: record?.[postValueKey], action, remarks }];
    // const res = await Utilities.fetchWithAuth('POST', saveEndpoint, data, navigate);
    // if (res.ok) {
    //     setRecord?.({ record, action });
    // }
    // table.setLoading(false);
  }

  return (
    <>
      <div className="">
        <Row gutter={[16, 0]}>
          <Col xs={24} /*xl={saveEndpoint ? 16 : 24}*/ xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace p-2"
              title={label}
              // extra={
              //     saveEndpoint && (<Space>
              //         <Button /*loading={loading}*/ className='btn-success border-0' onClick={e => changeStatus()} icon={<i className='far fa-thumbs-up' />}>Approve All</Button>
              //         <Button /*loading={loading}*/ className='btn-danger border-0' onClick={e => changeStatus()} icon={<i className='far fa-thumbs-down' />}>Decline All</Button>
              //     </Space>)
              // }
            >
              <div className="table-responsivex">
                {table.tableWithHeaderFooter(
                  CustomFunctions.tblCaption,
                  CustomFunctions.tblCaption,
                  { scroll: { x: "max-content" } },
                )}
              </div>
            </Card>
          </Col>
        </Row>

        {drawer.drawerJSX(
          1000,
          <>
            {viewJSX?.(
              itemToView /*, setExtraItemToView, extraDrawer, navigate*/,
            )}
            <Row className="mt-3" gutter={[12, 12]}>
              {!!invoices.length && (
                <Col xs={24} sm={24}>
                  <Card
                    style={{ background: "#fafafa" }}
                    title={"Act on Invoice"}
                  >
                    <div>
                      <label className="me-2">Status:</label>
                      <Select
                        value={status}
                        onChange={(e) => setStatus(e)}
                        placeholder="Select Status"
                        // style={{ width: 100 }}
                        // onChange={handleChange}
                        className="mb-2"
                        options={[
                          { value: "Completed", label: "Completed" },
                          { value: "Rejected", label: "Rejected" },
                        ]}
                      />
                    </div>
                    <div>
                      <label>Remarks:</label>
                      <TextArea
                        placeholder="Remarks"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        autoSize
                      />
                    </div>
                    <Button
                      onClick={submitInvoiceAction}
                      className="mt-2"
                      type="primary"
                      icon={<i className="fas fa-save" />}
                    >
                      Submit
                    </Button>
                  </Card>
                </Col>
              )}
              {invoices.map((file, i) => (
                <Col xs={12} sm={12} key={i}>
                  <Card
                    hoverable
                    size="small"
                    className="border border-1 rounded text-center"
                    // onClick={() => handlePreview(file.url)}
                    cover={
                      Utilities.isPdf(file.invoiceFile) ? (
                        <div
                          className="border border-1 d-flex justify-content-center"
                          style={{
                            height: 100,
                            background: "#fafafa",
                          }}
                        >
                          <FilePdfOutlined
                            style={{ fontSize: 36, color: "#cf1322" }}
                          />
                        </div>
                      ) : (
                        <Image
                          src={`${Settings.backend}${file.invoiceFile}`}
                          alt={file.invoiceFileName}
                          height={100}
                          width="100%"
                          style={{
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                          preview={false}
                        />
                      )
                    }
                  >
                    <div>
                      <Button
                        size="small"
                        type="link"
                        icon={<EyeOutlined />}
                        onClick={() =>
                          Utilities.openPdf(
                            `${Settings.backend}${file.invoiceFile}`,
                          )
                        }
                      >
                        View
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </>,
        )}
      </div>
    </>
  );
};

export default memo(ApproveDeclineSetup);
